import { render } from "./CreateCheck.vue?vue&type=template&id=115e1723"
import script from "./CreateCheck.vue?vue&type=script&lang=js"
export * from "./CreateCheck.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__